// extracted by mini-css-extract-plugin
module.exports = {"iconButton":"dialog-confirmation_iconButton__h9DXC","dialogContent":"dialog-confirmation_dialogContent__1Ck31"};